var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-amount-select"},[_c('range-slider',{attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.amount},on:{"input":_vm.updateAmount}}),_vm._v(" "),_c('sg-input',{staticClass:"product-amount-select__input",attrs:{"type":"number","min":_vm.min,"max":_vm.max,"value":_vm.amount},on:{"input":_vm.updateAmount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }